import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicByteStorage = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Byte Storage Methods: Big-Endian & Little-Endian"
      videos={[
        "https://www.youtube.com/embed/3JwSCZjdWqM",
        "https://www.youtube.com/embed/qIQNh1WGXLo"
      ]}
      takeaways={[
        { text: "Mainly theoretical questions, but numerical questions (ordering bytes) are easy." },
        { text: "Learn the differences between Big-Endian and Little-Endian." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicByteStorage;
